import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=af1fd8a4&scoped=true&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"
import style0 from "./patients.vue?vue&type=style&index=0&id=af1fd8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1fd8a4",
  null
  
)

export default component.exports